module.exports = __webpack_public_path__ + "img/illustration-features.5799cbe1.png";